module.exports = __webpack_public_path__ + "assets/map-transparent.94edb56c.svg";